package com.tixforgigs.common.core.theme

import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import io.kvision.theme.Theme
import io.kvision.theme.ThemeManager
import kotlinx.browser.window
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

object TixTheme {

  val tixThemeFlow = MutableStateFlow(initialTheme)

  val initialTheme: Theme
    get() {
      val userPreference = window.localStorage.getItem("kvision-bootstrap-theme")
      return if (userPreference.isNullOrBlank()) {
        if (window.matchMedia("(prefers-color-scheme: dark)").matches) Theme.DARK else Theme.LIGHT
      } else runCatching { Theme.valueOf(userPreference.uppercase()) }.getOrDefault(Theme.LIGHT)
    }

  init {
    AppScope.launch {
      tixThemeFlow.collect { theme ->
        ThemeManager.theme = theme
      }
    }
  }
}
